export default [
  { count: 266, date: '2020-03-24' },
  { count: 296, date: '2020-03-25' },
  { count: 428, date: '2020-03-26' },
  { count: 420, date: '2020-03-27' },
  { count: 357, date: '2020-03-28' },
  { count: 389, date: '2020-03-29' },
  { count: 686, date: '2020-03-30' },
  { count: 588, date: '2020-04-01' },
  { count: 517, date: '2020-04-02' },
  { count: 596, date: '2020-04-03' },
  { count: 453, date: '2020-04-04' },
  { count: 443, date: '2020-04-05' },
  { count: 303, date: '2020-04-06' },
  { count: 302, date: '2020-04-07' },
  { count: 593, date: '2020-04-08' },
  { count: 649, date: '2020-04-09' },
  { count: 682, date: '2020-04-10' },
  { count: 607, date: '2020-04-11' },
  { count: 518, date: '2020-04-12' },
  { count: 649, date: '2020-04-13' },
  { count: 593, date: '2020-04-14' },
  { count: 767, date: '2020-04-15' },
  { count: 3034, date: '2020-04-30' },
  { count: 9951, date: '2020-04-16' },
  { count: 8405, date: '2020-04-17' },
  { count: 11505, date: '2020-04-18' },
  { count: 8725, date: '2020-04-19' },
  { count: 163189, date: '2020-04-20' },
  { count: 284169, date: '2020-04-21' },
  { count: 86208, date: '2020-04-22' },
  { count: 35296, date: '2020-04-23' },
  { count: 34439, date: '2020-04-24' },
  { count: 26384, date: '2020-04-25' },
  { count: 16582, date: '2020-04-26' },
  { count: 4144, date: '2020-04-27' },
  { count: 12602, date: '2020-04-28' },
  { count: 1822, date: '2020-04-29' },
  { count: 1155, date: '2020-05-11' },
  { count: 7059, date: '2020-05-12' },
  { count: 7686, date: '2020-05-18' },
  { count: 6262, date: '2020-05-17' },
  { count: 7590, date: '2020-05-16' },
  { count: 7528, date: '2020-05-15' },
  { count: 7909, date: '2020-05-14' },
  { count: 7945, date: '2020-05-13' },
  { count: 2286, date: '2020-05-01' },
  { count: 1916, date: '2020-05-02' },
  { count: 2380, date: '2020-05-03' },
  { count: 5732, date: '2020-05-04' },
  { count: 5940, date: '2020-05-05' },
  { count: 5745, date: '2020-05-06' },
  { count: 5104, date: '2020-05-07' },
  { count: 8010, date: '2020-05-08' },
  { count: 7019, date: '2020-05-09' },
  { count: 12789, date: '2020-05-10' },
  { count: 5540, date: '2020-05-19' },
  { count: 7696, date: '2020-05-20' },
  { count: 5966, date: '2020-05-21' },
  { count: 4078, date: '2020-05-22' },
  { count: 4514, date: '2020-05-23' },
  { count: 4865, date: '2020-05-24' },
  { count: 7127, date: '2020-05-25' },
  { count: 7268, date: '2020-05-26' },
  { count: 6724, date: '2020-05-27' },
  { count: 4655, date: '2020-05-28' },
  { count: 5394, date: '2020-05-29' },
  { count: 5562, date: '2020-05-30' },
  { count: 4521, date: '2020-05-31' },
  { count: 6015, date: '2020-06-01' },
  { count: 6148, date: '2020-06-02' },
  { count: 3545, date: '2020-06-03' },
  { count: 5140, date: '2020-06-04' },
  { count: 4077, date: '2020-06-05' },
  { count: 2955, date: '2020-06-06' },
  { count: 4073, date: '2020-06-07' },
  { count: 7553, date: '2020-06-08' },
  { count: 5323, date: '2020-06-09' },
  { count: 4943, date: '2020-06-10' },
  { count: 3976, date: '2020-06-11' },
  { count: 4850, date: '2020-06-12' },
  { count: 5900, date: '2020-06-13' },
  { count: 5564, date: '2020-06-14' },
  { count: 5803, date: '2020-06-15' },
  { count: 4066, date: '2020-06-16' },
  { count: 11595, date: '2020-06-17' },
  { count: 10991, date: '2020-06-18' },
  { count: 4571, date: '2020-06-19' },
  { count: 5395, date: '2020-06-20' },
  { count: 7529, date: '2020-06-21' },
  { count: 15197, date: '2020-06-22' },
  { count: 10508, date: '2020-06-23' },
  { count: 9882, date: '2020-06-24' },
  { count: 4618, date: '2020-06-25' },
  { count: 4180, date: '2020-06-26' },
  { count: 4722, date: '2020-06-27' },
  { count: 1706, date: '2020-06-28' },
  { count: 11073, date: '2020-06-29' },
  { count: 3772, date: '2020-06-30' },
  { count: 2244, date: '2020-07-01' },
  { count: 3068, date: '2020-07-02' },
  { count: 4866, date: '2020-07-03' },
  { count: 2107, date: '2020-07-04' },
  { count: 6465, date: '2020-07-05' },
  { count: 3266, date: '2020-07-06' },
  { count: 3002, date: '2020-07-07' },
  { count: 4848, date: '2020-07-08' },
  { count: 2729, date: '2020-07-09' },
  { count: 3504, date: '2020-07-10' },
  { count: 2188, date: '2020-07-11' },
  { count: 2560, date: '2020-07-12' },
  { count: 4904, date: '2020-07-13' },
  { count: 3305, date: '2020-07-14' },
  { count: 6399, date: '2020-07-15' },
  { count: 1921, date: '2020-07-16' },
  { count: 6132, date: '2020-07-17' },
  { count: 3166, date: '2020-07-18' },
  { count: 2746, date: '2020-07-19' },
  { count: 3597, date: '2020-07-20' }
];
